import React, { ComponentProps } from "react";

export default function PersonFilledIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6 12.0665V13.6665H2.4V12.0665C2.4 12.0665 2.4 8.86653 8 8.86653C13.6 8.86653 13.6 12.0665 13.6 12.0665ZM10.8 4.46654C10.8 3.91276 10.6358 3.37141 10.3281 2.91095C10.0205 2.45049 9.58314 2.09161 9.07151 1.87969C8.55988 1.66776 7.99689 1.61231 7.45375 1.72035C6.9106 1.82839 6.41169 2.09506 6.0201 2.48665C5.62852 2.87823 5.36184 3.37714 5.25381 3.92029C5.14577 4.46344 5.20122 5.02642 5.41314 5.53805C5.62507 6.04968 5.98395 6.48698 6.4444 6.79465C6.90486 7.10232 7.44621 7.26653 8 7.26653C8.7426 7.26653 9.45479 6.97154 9.97989 6.44644C10.505 5.92134 10.8 5.20915 10.8 4.46654Z"
        fill="currentColor"
      />
    </svg>
  );
}
